import { getFilenameFromURL } from 'shared/utils/get-filename-from-url';

export const getRace = (link: string) => {
	const bodyFilename = getFilenameFromURL(link || '');
	const splitFilename = bodyFilename ? bodyFilename.split('_') : [];

	return splitFilename[splitFilename.length - 2];
};
